import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import { PropsModel, PropsSideEnum } from '../../Models/MiniGames/PropsModel';
import { DialogTextEnum, DialogTypeTextEnum } from '../../Models/GameModel';

@Singleton
export class PropsLogic {
    constructor(
        @Inject private _model: PropsModel,
        @Inject private _modelEvents: ModelEvents
    ) {}

    public start(): void {
        this._model.step = 1;
    }

    public nextStep(): void {
        this._model.step++;
    }

    public isComplete(): boolean {
        return this._model.step > this._model.stepMax;
    }

    public isRightSide(side: PropsSideEnum): boolean {
        return this._model.rightSides[this._model.step - 1] === side;
    }

    public reset(): void {
        this._model.step = 1;
    }
}
